import React, { useState } from 'react'
import { Row, Col, Button, Radio, Input, Space, Menu, Dropdown } from 'antd'
import './Payment.css';
import Visa from "../../assets/img/Visa.png"
import Mastercard from "../../assets/img/mastercard.png"
import AmericanExpress from "../../assets/img/american-express.png"

import history from "../../routes/history";

export default function Payment() {
    const [value, setvalue]=useState();
    const [bankname, setbankname]=useState();

    const onChange =(e) => {
       setvalue({
          value: e.target.value,
        });
      };

      const onClick = ({ key }) => {
        setbankname(key);
      };
      
      const menu = (
        <Menu onClick={onClick}>
          <Menu.Item key="Citi Group">Citi group</Menu.Item>
          <Menu.Item key="Jp Morgan">Jp Morgan</Menu.Item>
          <Menu.Item key="Bank Of America">Bank of America</Menu.Item>
          <Menu.Item key="Truist Bank">Truist Bank</Menu.Item>
          <Menu.Item key="PNC">PNC</Menu.Item>
          <Menu.Item key="Bank Of New York Mellon">Bank of New York Mellon</Menu.Item>
        </Menu>
    
      );  
    

return (
<div className='payment-center'>
    <Col xs={22} sm={22} md={12} lg={12} xl={12}>
<div className='payment-option-container'>
     <div className='payment-option'>Choose payment option</div>
 
<Radio.Group onChange={(e)=>onChange(e)} value={value}>
        <Space direction="vertical">
          <Radio value={1} className="payment-option2">Credit or debit cards</Radio>
          <Radio value={2} className="payment-option2">Apple pay</Radio>
          <Radio value={3} className="payment-option2">Internet banking</Radio>
        </Space>
  </Radio.Group>
 
</div>
    <div className='payment-det'>Payment details</div>
    <div className='payment-pic'>
    <img src={Visa} alt="Visa" className='payment-pic-dim' />
    <img src={Mastercard} alt="Mastercardimg" className='payment-pic-dim' />
    <img src={AmericanExpress} alt="AmericanExpressimg" className='payment-pic-dim' />
    </div>
 

   
    <Row className="payment-heading">
    <div className="payment-title">Card number</div>
    <div className="payment-asterik"> *</div>
  </Row>
  <Input className='payment-inp'/>
   <Row className="payment-heading">
   <div className="payment-title">Expiry date</div>
   <div className="payment-asterik"> *</div>
 </Row>
 <Input className='payment-inp'/>
  <Row className="payment-heading">
  <div className="payment-title">Security code</div>
  <div className="payment-asterik"> *</div>
</Row>
<Input className='payment-inp'/>
<div>
{/* <div className='payment-det'>Bank Details</div> */}
{/* <Row className="payment-heading">
  <div className="payment-title">Bank Name</div>
  <div className="payment-asterik"> *</div>
</Row> */}

{/* <Dropdown
              overlay={menu}
              // className={`contractgig-input ${jobDurationError ? "InputDropdownError" : ""}`}
            // style={{ background: "blue" }}
            >
              <Button
                style={{
                  width: "100%",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {bankname} <DownOutlined />
              </Button>
</Dropdown> */}
</div>
<div>
    <Button className='payment-btn' onClick={()=>history.push("/allset")}>Submit</Button>
</div>
</Col>
</div>
)
}
